import { render, staticRenderFns } from "./PersonalProfile.vue?vue&type=template&id=5f203597&"
import script from "./PersonalProfile.vue?vue&type=script&lang=js&"
export * from "./PersonalProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports